import { AAGUID } from '@interticket/core';
import { Observable } from 'rxjs';
import { SearchParams } from '@core/models/query-params/search-params.model';
import { EventFilter } from '@core/models/event/event-filter.model';
import { IListResult } from '../list-result/list-result.interface';
import { IEventView } from './event-view.interface';
import { IEventListItem } from './event-list-item.interface';
import { IEventViewBase } from './event-view-base.interface';

export abstract class IEventsSource {

  abstract getEvent(eventId: AAGUID): Observable<IEventView>;
  abstract getList(searchParams?: SearchParams, filter?: EventFilter): Observable<IListResult<IEventListItem>>;
  abstract getMoreEvents(id: AAGUID): Observable<IListResult<IEventViewBase>>;
  abstract getListByIds(eventIds: AAGUID[]): Observable<IEventView[]>;
  abstract getCalendarEvents(): Observable<IListResult<IEventViewBase>>;

}
